export default __webpack_public_path__ + "static/media/tree.04b191c9.svg";